const currentPartners = [
  {
    details: [
      ["Locations", "Multnomah County"],
      ["Income Restrictions", "Low-income only"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "$34"],
    ],
    name: "CLEAR Clinic",
    area: "Northeast Portland",
    instructions: "Contact",
    contacts: ["Leni Tupper", "info@clear-clinic.org"],
    website: "https://clear-clinic.org/",
  },
  {
    details: [
      ["Locations", "Portland Metro"],
      ["Income Restrictions", "None"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "$434 flat fee"],
    ],
    name: "Qiu-Qiu Law",
    area: "Portland",
    instructions: "Check your eligibility",
    contacts: [""],
    website: "https://www.qiu-qiulaw.com/register",
  },
  {
    details: [
      ["Locations", "Portland Metro"],
      ["Income Restrictions", "Unknown"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "Unknown"],
    ],
    name: "Clackamas Workforce Partnership",
    area: "Oregon City",
    instructions: "Contact",
    contacts: ["Amanda Wall", "expungement@clackamasworkforce.org"],
    website: "https://www.clackamasworkforce.org/for-people/expungement-clinics/",
  },
  {
    details: [
      ["Locations", "Jackson County"],
      ["Income Restrictions", "None"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "$434 flat fee"],
    ],
    name: "Signs of Hope (Qiu-Qiu Law)",
    area: "Medford",
    instructions: "Contact",
    contacts: ["Sarah Kolb", "hope@janekolb.com", "541-821-5577"],
    website: "https://www.janekolb.com",
  },
  {
    details: [
      ["Locations", "Umatilla County"],
      ["Income Restrictions", "None"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "Free"],
    ],
    name: "Pendleton Legal Aid Services of Oregon",
    area: "Pendleton",
    instructions: "Contact",
    contacts: ["Arron Guevara", "arron.guevara@lasoregon.org"],
    website: "https://www.facebook.com/pendletonlegalaid/",
  },
  {
    details: [
      ["Locations", "Southern Oregon Coast"],
      ["Income Restrictions", "None"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "Free"],
    ],
    name: "Bay Area First Step",
    area: "Coos Bay",
    instructions: "Contact",
    contacts: ["Devin Bailey Wilson", "dwilson@bayareafirststep.org"],
    website: "https://bayareafirststep.org/",
  },
  {
    details: [
      ["Locations", "Central Oregon"],
      ["Income Restrictions", "None"],
      ["Analysis Cost", "Free"],
      ["Paperwork Cost", "Free"],
    ],
    name: "Linn-Benton Community College",
    area: "Albany",
    instructions: "Contact",
    contacts: ["Drew Hastings", "hastind@linnbenton.edu"],
    website: "https://www.linnbenton.edu",
  },
];

export default currentPartners;
